<div class="c-schedule bg d-flex">
  <div class="c-calendar bg-white" [ngClass]="{'c-calendar-show': showCardBlue}">
    <app-calendar-header [(view)]="view" [locale]="locale" [(viewDate)]="viewDate"></app-calendar-header>

    <div [ngSwitch]="view">
      <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="viewDate" [events]="events"
        (columnHeaderClicked)="clickedColumn = $event" (dayClicked)="clickedDate = $event.day.date"
        (click)="clickDay()">
      </mwl-calendar-month-view>
      <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate" [events]="events"
        (dayHeaderClicked)="clickedDate = $event.day.date">
      </mwl-calendar-week-view>
      <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate" [events]="events">
      </mwl-calendar-day-view>
    </div>
  </div>
  <div class="view-schedule" [ngClass]="{'show-card': showCardBlue}">
    <div class="view-schedule_cont text-center color-white">
      <div class="schedule-date">
        <p class="color-yellow u-uppercase">{{ date.month }} {{ date.day }}</p>
      </div>
      <div class="schedule-text overflow-text-calendar">
        <img class="icon-warning" src="./assets/icons/warning-yellow.svg" alt="Icono Advertencia">
        <h3 class="color-white font-20">{{pInfoDate.text}}</h3>
        <p class="font-14" [innerHTML]="pInfoDate.text_html"></p>
      </div>
    </div><!-- /view-schedule -->
  </div>
</div>
